/** Polling a queued transaction starts its work, so only one poller per transaction. */
const locallyDrivenTransactionIds = new Set<string>();

const nonEmptyIds = (transactionIds: readonly string[]): readonly string[] =>
  transactionIds.filter((id) => typeof id === "string" && id.length > 0);

export function claimTransactionPolling(transactionIds: readonly string[]): void {
  for (const id of nonEmptyIds(transactionIds)) {
    locallyDrivenTransactionIds.add(id);
  }
}

export function releaseTransactionPolling(transactionIds: readonly string[]): void {
  for (const id of nonEmptyIds(transactionIds)) {
    locallyDrivenTransactionIds.delete(id);
  }
}

export function isTransactionPolledLocally(transactionId: string): boolean {
  return locallyDrivenTransactionIds.has(transactionId);
}
